import { log } from '@/logger/logger';
import { getAxiosInstance } from '@/services/axiosConfig';

const logger = log.getLogger('fal.api');
const axiosInstance = getAxiosInstance();

export const getFalModel = async (falUrl: string) => {
  try {
    const res = await axiosInstance.post<{ name: string; schema: Record<string, any>; version: string }>(
      `/v1/models/fal/model`,
      {
        url: falUrl,
      },
    );

    return res.data;
  } catch (e) {
    logger.error('Could not get fal model', e);
  }
};
